import type { SVGProps } from 'react';

/**
 * An open padlock drawn like iconoir's `Lock` (24 grid, 1.5 stroke,
 * currentColor), which the installed iconoir has no open variant of.
 */
export const LockOpenIcon = ({
  width = '1em',
  height = '1em',
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M16 12H17.4C17.7314 12 18 12.2686 18 12.6V19.4C18 19.7314 17.7314 20 17.4 20H6.6C6.26863 20 6 19.7314 6 19.4V12.6C6 12.2686 6.26863 12 6.6 12H8M16 12V8C16 6.66667 15.2 4 12 4C10.0867 4 9.03133 4.95333 8.48467 6M16 12H8" />
  </svg>
);
